import { render, staticRenderFns } from "./LocationOverviewRelation.vue?vue&type=template&id=6f1f89ac&scoped=true&"
import script from "./LocationOverviewRelation.vue?vue&type=script&lang=js&"
export * from "./LocationOverviewRelation.vue?vue&type=script&lang=js&"
import style0 from "./LocationOverviewRelation.vue?vue&type=style&index=0&id=6f1f89ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1f89ac",
  null
  
)

export default component.exports